import React from "react";
import Hero from "../components/home/Hero";
import StatsBar from "../components/home/StatsBar";
import WhyNow from "../components/home/WhyNow";
import InvestmentFocus from "../components/home/InvestmentFocus";
import ValueCreation from "../components/home/ValueCreation";
import AudienceSection from "../components/home/AudienceSection";
import ContactForm from "../components/home/ContactForm";

export default function Home() {
  return (
    <div className="min-h-screen">
      <section id="hero">
        <Hero />
      </section>

      <StatsBar />

      <section id="why-now">
        <WhyNow />
      </section>

      <section id="invest-in">
        <InvestmentFocus />
      </section>

      <section id="value">
        <ValueCreation />
      </section>

      <section id="investors">
        <AudienceSection 
          type="investors"
          title="For Investors"
          subtitle="Investors partner with us to access Europe’s defence growth and Ukraine’s innovation safely, leveraging our expertise and diversified high-potential portfolio."
        />
      </section>

      <section id="founders">
        <AudienceSection 
          type="founders"
          title="For Founders & SME Owners"
          subtitle="Scale your mission-critical technology with capital, grants, and operational support"
        />
      </section>

      <section id="contact">
        <ContactForm />
      </section>
    </div>
  );
}